var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent_form"},_vm._l((_vm.schema),function(field,index){return _c(field.type,_vm._b({key:index,tag:"component",staticClass:"input_form_field",attrs:{"value":_vm.formData[field.name]},on:{"input":function($event){return _vm.updateForm(field.name, $event)}}},'component',field,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }